import { TraderActions } from './trader.actions';

export class ProfileTrader {
    public userId: number;
    public isTrader: boolean;
    public profileInfo: ProfileInfo; 
    public dateFirstOperation?: Date; 
    public dateLastOperation?: Date; 
    public contractCurrentMonth: number; 
    public contractLastMonth: number; 
    public rankingPosition: number;
    public rankingMounth?: number;
    public platforms: Array<string>;
    public clubTrader: ClubTrader;
    public createdAt?: Date;
    public updatedAt?: Date;
    constructor() {
        this.userId = 0;
        this.isTrader = false;
        this.profileInfo = new ProfileInfo();
        this.dateFirstOperation = null;
        this.dateLastOperation = null;
        this.contractCurrentMonth = 0;
        this.contractLastMonth = 0;
        this.rankingPosition = 0;
        this.platforms = [];
        this.clubTrader = new ClubTrader();
        this.createdAt = null;
        this.updatedAt = null;
    }
}

export class ProfileInfo {
    typeProfile: string;
    dateEntry?: Date;
    dateDue?: Date;
}

export class ClubTrader {
    starter: {
        minimum: number;
        maximum: number;
    };
    master: {
        minimum: number;
        maximum: number;
    };
    vip: {
        minimum: number;
        maximum?: number;
    }
}

export class ProfileTraderState {
    public profile: ProfileTrader;
}

export const initialState: ProfileTraderState = {
    profile: new ProfileTrader()
};

export function traderReducer(state = initialState, action?: TraderActions) {

    switch (action.type) {

        // Trader

        case TraderActions.getProfileTrader:
            return { ...state, ...{ profile: state.profile, errors: null, pending: true }};

        case TraderActions.getProfileTraderError:
            return { ...state, ...{ errors: action.payload, pending: false }};

        case TraderActions.getProfileTraderSuccess:
            return { ...state, ...{ profile: action.payload, pending: false, errors: null}};

        default:
            return state;
    }
}
